export var defaultTransitionDuration = '.3s';
//# sourceMappingURL=config.js.map